import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import PropTypes from 'prop-types';

const InputField = props => {
    const {
        error,
        validationError,
        validationWarning,
        skeleton,
        helperText,
        placeholder,
        label,
        value,
        id,
        size,
        disabled,
        onChange,
        autoFocus,
        required,
        onBlur,
        adornmentComponent,
        onFocus,
    } = props;

    // eslint-disable-next-line no-nested-ternary
    const defaultAdornment = validationError ? (
        <ErrorOutlineIcon color="error" />
    ) : validationWarning ? (
        <WarningAmberIcon color="warning" />
    ) : null;

    const handleChange = e => {
        onChange(e.target.value);
    };

    return (
        <>
            <FormControl
                disabled={disabled}
                className="textInputFormControl"
                size={size}
                error={error}
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                skeleton={skeleton}
                required={required}>
                {label?.length > 0 && <InputLabel htmlFor={id}>{`${label}`}</InputLabel>}
                <OutlinedInput
                    placeholder={placeholder}
                    id={id}
                    value={value}
                    autoFocus={autoFocus}
                    aria-describedby="input"
                    endAdornment={
                        (defaultAdornment || adornmentComponent) && (
                            <InputAdornment position="end">{adornmentComponent ?? defaultAdornment}</InputAdornment>
                        )
                    }
                    onFocus={onFocus}
                />
                <FormHelperText id="helper-text">{helperText || ' '}</FormHelperText>
            </FormControl>
        </>
    );
};

InputField.propTypes = {
    error: PropTypes.bool,
    validationError: PropTypes.bool,
    validationWarning: PropTypes.bool,
    skeleton: PropTypes.bool,
    helperText: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    autoFocus: PropTypes.bool,
    required: PropTypes.bool,
    adornmentComponent: PropTypes.node,
    onFocus: PropTypes.func,
};

InputField.defaultProps = {
    error: false,
    validationError: false,
    validationWarning: false,
    skeleton: false,
    helperText: ' ',
    placeholder: '',
    label: '',
    value: '',
    id: 'cw-id',
    size: 'medium',
    disabled: false,
    onChange: () => {},
    onBlur: () => {},
    autoFocus: false,
    required: false,
    adornmentComponent: null,
    onFocus: () => {},
};

export default InputField;
